import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, ConfigProvider, Flex, Typography } from "antd";
import PageHeading from "components/PageHeading.component";
import PATHS from "shared/constants/paths";
import { translate } from "shared/languages";
import { modalButtonsTheme } from "components/modals/ModalChrome";

// The "save Pengaturan Penggajian first" empty state shared by every payroll
// spoke page that needs the payroll_setting row to exist (Run Payroll, a
// class's commission page). Pengaturan Penggajian itself never renders this:
// it locks its own downstream cards in place instead (see index.tsx), since
// the settings card is the one thing a fresh studio must be able to use.
// `heading` is the spoke's own muted back-link, rendered through the same
// PageHeading slot as its normal state so the page doesn't jump between the
// two.
const PayrollSettingsRequired = ({
  heading,
  title,
  description,
}: {
  heading: ReactNode;
  title?: string;
  description: string;
}) => {
  const navigate = useNavigate();
  return (
    <>
      <PageHeading title={heading} />
      {title && (
        <Typography.Title level={3} style={{ margin: "0 0 20px" }}>
          {title}
        </Typography.Title>
      )}
      <Card styles={{ body: { padding: 18 } }}>
        <Flex vertical gap={12} align="flex-start">
          <Typography.Text>{description}</Typography.Text>
          <ConfigProvider theme={modalButtonsTheme}>
            <Button type="primary" onClick={() => navigate(PATHS.PAYROLL)}>
              {translate("payrollPage.settings.required_cta")}
            </Button>
          </ConfigProvider>
        </Flex>
      </Card>
    </>
  );
};

export default PayrollSettingsRequired;
